import { t } from 'i18next';
import * as R from 'ramda';
import React from 'react';
import styled from 'styled-components';

import { getThemeSize, getThemeColor, getScreenSize } from '../../../../utils/theme';

export const FieldCommentWrapS = styled.div`
  min-height: 50px;
  width: auto;
  max-width: ${R.propOr('100%', 'maxWidth')};
  display: flex;
  flex-direction: column;
  justify-content: center;

  position: relative;
  background: ${getThemeColor(['grayBlue'])};
  border-radius: 2px;
  padding: 4px 12px 10px 0;
  margin-top: ${R.propOr('0', 'marginTop')};
  margin-bottom: 0;
  margin-left: 25px;
  margin-right: 20px;

  &:before {
    content: '';
    position: absolute;
    top: 25px;
    left: -6px;
    transform: rotate(45deg);
    background-color: ${getThemeColor(['grayBlue'])};
    width: 12px;
    height: 12px;
    border-radius: 2px;
  }

  @media (max-width: ${getScreenSize(['tabletPC'])}) {
    max-width: 100%;
    width: 100%;
    margin-top: ${R.propOr('15px', 'marginTopScreenTablet')};
    margin-bottom: ${R.propOr('0', 'marginBottomScreenTablet')};
    margin-left: 0;
    margin-right: 0;

    &:before {
      top: -6px;
      left: 10%;
      transform: rotate(45deg);
    }
  }

  &.angle-down {
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 10px;

    &:before {
      top: 100%;
      left: 50%;
      transform: rotate(45deg) translateX(-8px);
    }

    @media (max-width: ${getScreenSize(['tabletPC'])}) {
      margin-top: 0;
    }
  }
`;

const FieldCommentItemS = styled.p`
  position: relative;
  margin-top: 8px;
  margin-left: 30px;
  font-size: ${getThemeSize(['smallText'])};
  color: ${getThemeColor(['violet'])};
  line-height: 16px;
  &:before {
    content: '';
    position: absolute;
    left: -11px;
    top: 4px;
    display: inline-block;
    background-color: ${getThemeColor(['violet'])};
    width: 5px;
    height: 5px;
    border-radius: 50%;
  }
  &.list-type-none {
    &:before {
      display: none;
    }
  }

  @media (max-width: ${getScreenSize(['medium'])}) {
    font-size: ${getThemeSize(['middleSmallText'])};
  }
`;

const FieldComment = ({ transPath, className, ...rest }) => (
  <FieldCommentWrapS {...{ ...rest }} className={className || ''}>
    {t(transPath, { returnObjects: true }).map((comment, k) => (
      <FieldCommentItemS key={k} className={t(transPath, { returnObjects: true }).length < 2 ? 'list-type-none' : ''}>
        {comment}
      </FieldCommentItemS>
    ))}
  </FieldCommentWrapS>
);
export default FieldComment;
